import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';
import { useLayoutContext } from '../../LayoutContext';
import styles from './Title.module.scss';

interface TextProps {
    className: string;
    Component?: any;
}

const Text: React.FC<TextProps> = ({
    className,
    Component = 'div',
    ...props
}) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Component className={clsx(styles.text, className)} {...props} />
);

interface TitleProps {
    id: number;
    title: string;
}

const Title: React.FC<TitleProps> = ({ id, title = '' }) => {
    const { embedded } = useLayoutContext();

    return (
        <Text className={styles.text}>
            <Link href={`/purchases/${id}/main`}>
                <a
                    className={styles.link}
                    target={embedded ? '_blank' : undefined}
                >
                    {title || '[без названия]'}
                </a>
            </Link>
        </Text>
    );
};

export default Title;
